module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_5012.67160764.png";